
export default {
  token: null,
  user:  null,
  role: null,
  notifications: []
}
